import { configureStore } from "@reduxjs/toolkit";
import userSelectorReducer from "./userSelector";
import counterSlice from "./newsCounter";
import searchSlice from "./searchSelector";
import viewsSlice from "./newsVews";
import calendarSlice from "./calendarSelector";
import comentSlice from "./comentSelector";
import emailSlice from "./emailSelector";
import captchaSlice from "./captchaSelector";
import LikeComentCounterSlice from "./counterComentLikeSelector";
import themeSlice from "./themeSelector";
export default configureStore({
  reducer: {
    userSelector: userSelectorReducer,
    newsSelector: counterSlice,
    searchSelector: searchSlice,
    vewsSelector: viewsSlice,
    calendarSelector: calendarSlice,
    comentSelector: comentSlice,
    emailSelector: emailSlice,
    captchaSelector: captchaSlice,
    counterComentLikeSelector: LikeComentCounterSlice,
    themeSelector: themeSlice,
  },
});
